import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

// Import your different video files here
import BgVideo1 from "../assets/HeroImg/MolecularScixhero.mp4";
import BgVideo2 from "../assets/HeroImg/TechnologyHero.mp4";
import BgVideo3 from "../assets/HeroImg/HeroVideo.mp4";
import BgVideo4 from "../assets/HeroImg/HeroVideo.mp4";
import BgVideo5 from "../assets/HeroImg/CorporateTraining.mp4";

import "./HeroImg.css";

export default function HeroImg() {
  const [activeSlide, setActiveSlide] = useState(0);
  const totalSlides = 5;
  const videoRef = useRef(null);

  // Slide interval logic
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prevSlide) => (prevSlide + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const slides = [
    {
      title: "MolecularSciX.ai – Intelligence for Next-Generation Molecular Discovery",
      subtitle: "Accelerate Discovery. Optimize Chemistry. Transform R&D.",
      description: "MolecularSciX.ai empowers pharma, biotech, and research teams to move beyond traditional trial-and-error discovery. Built for modern molecular innovation, the platform brings predictive AI, chemical intelligence, and scientific automation together to help researchers identify better molecules, optimize pathways, reduce risk, and make faster decisions with confidence.",
      buttonText: "Schedule a Demo",
      video: BgVideo1, // Assigned video 1
    },
    {
      title: "Delivering tailored digital experiences with",
      subtitle: "Emerging and Disruptive Technology.",
      description: "Vedalytics leverages emerging and disruptive technologies to create personalized, impactful digital experiences, pioneering innovative tools through advanced R&D to drive business success and build a more connected world.",
      buttonText: "Know More",
      video: BgVideo2, // Assigned video 2
    },
    {
      title: "MantrAI AI-Powered Developer Tools",
      subtitle: "Boosting productivity",
      description:"MantrAI is designed to serve as an intelligent and user-friendly platform for developers of all experience levels, from beginners seeking educational support to professionals looking to improve efficiency and precision in their workflows.",
      buttonText: "Schedule a Demo",
      video: BgVideo3, // Assigned video 3
    },
    {
      title: "Veda Quantum.AI - A local LLM/SLM solution",
      subtitle: "Delivering Generative AI",
      description:"By integrating the contextual depth of RAG with the autonomy of Agentic AI, this solution transforms how organizations interact with data, streamline operations & enhance customer engagement driving innovation & fostering sustainable growth in today’s digital-first landscape.",
      buttonText: "Schedule a Demo",
      video: BgVideo4, // Assigned video 4
    },
    {
      title: "Vedalytics Corporate and Industrial Advance training for",
      subtitle: "Fresher and IT professionals",
      description:"We provide specialized IT training for freshers and professionals, covering AI, Data Science, Machine Learning, NLP, Cloud Computing, DevOps, Python, and more. Gain skills to thrive in today's tech-driven world.",
      buttonText: "Learn More",
      video: BgVideo5, // Assigned video 5
    },
  ];

  // Trigger video load & custom speed whenever the active slide changes
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.75; // Maintain slow speed
      videoRef.current.load(); // CRITICAL: Forces HTML5 player to fetch the new video src
    }
  }, [activeSlide]); // Runs every time activeSlide changes

  const CarouselIndicator = ({ index, active }) => (
    <li className={`carousel-indicator ${active ? "active" : ""}`}>
      <div
        className="indicator-fill"
        style={{
          animationDuration: "5s",
          animationPlayState: active ? "running" : "paused",
        }}
      ></div>
    </li>
  );

  return (
    <section
      className="hero-section"
      style={{ marginTop: "66px", position: "relative" }}
    >
      {/* Dynamic Video Background */}
      <video
        ref={videoRef}
        preload="auto"
        className="bg-video"
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        {/* Dynamically bind the source path to the active slide's video data */}
        <source src={slides[activeSlide].video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay to darken video for readability */}
      <div
        className="overlay"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.6)",
          zIndex: 1,
        }}
      ></div>

      <div
        className="carousel slide hero-carousel"
        id="carouselExampleIndicators"
      >
        <ol className="custom-indicators">
          {slides.map((_, index) => (
            <CarouselIndicator
              key={index}
              index={index}
              active={activeSlide === index}
            />
          ))}
        </ol>

        <div className="carousel-inner h-100">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-item ${activeSlide === index ? "active" : ""} h-100`}
            >
              <div className="container h-100">
                <div className="row h-100 align-items-center py-4 py-md-5">
                  <div className="col-12 col-lg-8 mb-4 mb-lg-0 hero-copy">
                    <h3
                      className="text-primary fw-bold mb-2 hero-slide-title"
                      style={{ textShadow: "1px 1px 4px rgba(0,0,0,0.6)" }}
                    >
                      {slide.title}
                    </h3>
                    <h2
                      className="text-warning fw-bold mb-3 hero-slide-subtitle"
                      style={{ textShadow: "1px 1px 4px rgba(0,0,0,0.6)" }}
                    >
                      {slide.subtitle}
                    </h2>
                    <p
                      className="text-light hero-slide-description"
                      style={{ textShadow: "1px 1px 4px rgba(0,0,0,0.6)" }}
                    >
                      {slide.description}
                    </p>
                    <Link
                      to="/scheduleDemo"
                      className="btn btn-outline-primary hero-slide-btn"
                    >
                      {slide.buttonText}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation arrows */}
        <a
          className="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
          onClick={(e) => {
            e.preventDefault();
            setActiveSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
          }}
        >
          <span
            className="carousel-control-prev-icon mr-5"
            aria-hidden="true"
          />
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
          onClick={(e) => {
            e.preventDefault();
            setActiveSlide((prev) => (prev + 1) % totalSlides);
          }}
        >
          <span
            className="carousel-control-next-icon ml-5"
            aria-hidden="true"
          />
          <span className="sr-only">Next</span>
        </a>
      </div>
    </section>
  );
}
